<template>
    <div class="Man-CF7MenuPrincipal">
        <PageTitle icon="fa fa-shopping" main="CF7"
            sub="STORE consulta de vales em aberto " />
        <div class="Man-CF7MenuPrincipal">
            <b-card no-body>
                <b-tabs>                                                            
                    <b-tab title="Parcelas" active><FuncionarioParcelas /></b-tab>      
                  
                    
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import FuncionarioParcelas from '../sambaiba/CF7FuncionariosParcelas'
export default {
    name: 'CF7MenuConsultaPrincipal',    
    components: {PageTitle,FuncionarioParcelas}
    
}
</script>

<style>

</style>







